import React from "react";
import { projects } from "data";
import ProjectDetails from "../ProjectDetails";

const Farmshare = React.forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      <ProjectDetails project={projects.find(project => project.name === 'Farmshare')} />
    </div>
  )
});

Farmshare.displayName = "Farmshare";

export default Farmshare;
